import type { RouteObject } from 'react-router'

import { lazyRoute } from '@web/app/routes/lazy-route'
import {
  ConfigurationRoute,
  EquipmentRoute
} from '@web/shared/constants/routes.constant'

const equipmentPageRoute = lazyRoute(
  () => import('@web/pages/configuration-equipment/ui/equipment-page'),
  ({ EquipmentPage }) => EquipmentPage
)

const connectionsRoute = lazyRoute(
  () =>
    import('@web/widgets/connections-configurator/ui/connections-configurator'),
  ({ ConnectionsConfigurator }) => ConnectionsConfigurator
)

const mnemonicPageRoute = lazyRoute(
  () => import('@web/pages/mnemonic/ui/mnemonic-page'),
  ({ MnemonicPage }) => MnemonicPage
)

const mnemonicRoute = lazyRoute(
  () => import('@web/widgets/mnemonic/ui/mnemonic'),
  ({ Mnemonic }) => Mnemonic
)

const connectionRoutes: RouteObject[] = [
  {
    path: ConfigurationRoute.Connections,
    lazy: connectionsRoute
  },
  {
    path: ConfigurationRoute.ConnectionsDevice,
    lazy: connectionsRoute
  }
]

const ConfigurationRouter: RouteObject[] = [
  {
    path: EquipmentRoute.GroupId,
    lazy: equipmentPageRoute,
    children: [
      {
        path: ConfigurationRoute.Equipment,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-equipment-group/ui/equipment-group-edit'
            ),
          ({ EquipmentGroupEdit }) => EquipmentGroupEdit
        )
      },
      {
        path: ConfigurationRoute.GroupAdd,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-equipment-group/ui/equipment-group-add'
            ),
          ({ EquipmentGroupAdd: EquipmentGroupDraft }) => EquipmentGroupDraft
        )
      },
      {
        path: ConfigurationRoute.MachineAdd,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-equipment-machine/ui/equipment-machine-add'
            ),
          ({ EquipmentMachineAdd: EquipmentMachineDraft }) =>
            EquipmentMachineDraft
        )
      },
      {
        path: ConfigurationRoute.MnemonicDiagram,
        lazy: mnemonicPageRoute,
        children: [
          {
            path: ':mnemoSchemeId',
            lazy: mnemonicRoute
          }
        ]
      },
      ...connectionRoutes
    ]
  },
  {
    path: EquipmentRoute.MachineId,
    lazy: equipmentPageRoute,
    children: [
      {
        path: ConfigurationRoute.Equipment,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-equipment-machine/ui/equipment-machine-edit'
            ),
          ({ EquipmentMachineEdit }) => EquipmentMachineEdit
        )
      },
      {
        path: ConfigurationRoute.PointAdd,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-equipment-point/ui/equipment-point-add'
            ),
          ({ EquipmentPointAdd: EquipmentPointDraft }) => EquipmentPointDraft
        )
      },
      {
        path: ConfigurationRoute.MnemonicDiagram,
        lazy: mnemonicPageRoute,
        children: [
          {
            path: ':mnemoSchemeId',
            lazy: mnemonicRoute
          }
        ]
      },
      {
        path: ConfigurationRoute.WorkMode,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-work-mode-machine/ui/work-mode-machine-page'
            ),
          ({ WorkModeMachinePage }) => WorkModeMachinePage
        )
      },
      {
        path: ConfigurationRoute.KinematicsDiagram,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-kinematic/ui/kinematic-configuration-page'
            ),
          ({ KinematicConfigurationPage }) => KinematicConfigurationPage
        )
      },
      ...connectionRoutes
    ]
  },
  {
    path: EquipmentRoute.PointId,
    lazy: equipmentPageRoute,
    children: [
      {
        path: ConfigurationRoute.Equipment,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-equipment-point/ui/equipment-point-edit'
            ),
          ({ EquipmentPointEdit }) => EquipmentPointEdit
        )
      },
      {
        path: ConfigurationRoute.MeasurementAdd,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-equipment-measurement/ui/equipment-measurement-add'
            ),
          ({ EquipmentMeasurementAdd: EquipmentMeasurementDraft }) =>
            EquipmentMeasurementDraft
        )
      },
      {
        path: ConfigurationRoute.MnemonicDiagram,
        lazy: mnemonicPageRoute,
        children: [
          {
            path: ':mnemoSchemeId',
            lazy: mnemonicRoute
          }
        ]
      },
      {
        path: ConfigurationRoute.WorkMode,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-work-mode-point/ui/work-mode-point-page'
            ),
          ({ WorkModePointPage }) => WorkModePointPage
        )
      },
      ...connectionRoutes
    ]
  },
  {
    path: EquipmentRoute.MeasurementId,
    lazy: equipmentPageRoute,
    children: [
      {
        path: ConfigurationRoute.Equipment,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-equipment-measurement/ui/equipment-measurement-edit'
            ),
          ({ EquipmentMeasurementEdit }) => EquipmentMeasurementEdit
        )
      },
      {
        path: ConfigurationRoute.Threshold,
        lazy: lazyRoute(
          () => import('@web/pages/threshold/ui/threshold-page'),
          ({ ThresholdPage }) => ThresholdPage
        )
      },
      {
        path: ConfigurationRoute.MnemonicDiagram,
        lazy: mnemonicPageRoute,
        children: [
          {
            path: ':mnemoSchemeId',
            lazy: mnemonicRoute
          }
        ]
      },
      {
        path: ConfigurationRoute.WorkMode,
        lazy: lazyRoute(
          () =>
            import(
              '@web/pages/configuration-work-mode-measurement/ui/work-mode-measurement-page'
            ),
          ({ WorkModeMeasurementPage }) => WorkModeMeasurementPage
        )
      }
    ]
  }
]

export default ConfigurationRouter
